/**
 *
 */

var Menu = (function($) {
  function initMenu() {
    // do something
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".header").length) {
      return;
    }

    initMenu();
    $("#go-to-top").click(function(e) {
      e.preventDefault();

      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  return {
    init: init,
  };
})(jQuery);

jQuery(document).ready(Menu.init);
